/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebselectphoto3Inputs */

const en_placewebselectphoto3 = /** @type {(inputs: Placewebselectphoto3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select photo`)
};

const de_placewebselectphoto3 = /** @type {(inputs: Placewebselectphoto3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foto auswählen`)
};

/**
* | output |
* | --- |
* | "Select photo" |
*
* @param {Placewebselectphoto3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebselectphoto3 = /** @type {((inputs?: Placewebselectphoto3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebselectphoto3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebselectphoto3(inputs)
	return de_placewebselectphoto3(inputs)
});
export { placewebselectphoto3 as "placeWebSelectPhoto" }